import styled from 'styled-components';
import AppCSS from '../../utils/styled';
import { SIDEBAR_COLLAPSED_WIDTH, SIDEBAR_WIDTH } from '../../utils/styled/dimensions';
import { ReactComponent as AngleLeftIcon } from '../../assets/icons/icon-angle-left.svg';

export const Components = {
  Container: styled.div<{ $isCollapsed?: boolean }>`
    display: flex;
    flex-direction: column;
    width: ${(p) => (p.$isCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH)}px;
    min-width: ${(p) => (p.$isCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH)}px;
    height: 100%;
    min-height: 100vh;
    background-color: ${AppCSS.colors.blues.veryDark};
    padding: ${(p) => (p.$isCollapsed ? '24px 12px' : '24px')};
    z-index: 99;
    overflow-x: hidden;
    overflow-y: auto;
    transition: width 0.2s ease, min-width 0.2s ease, padding 0.2s ease;
  `,

  HeaderRow: styled.div<{ $isCollapsed?: boolean }>`
    width: 100%;
    display: flex;
    flex-direction: ${(p) => (p.$isCollapsed ? 'column' : 'row')};
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  `,
  ToggleButton: styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    padding: 0;
    border: 1px solid ${AppCSS.colors.greys.v2};
    ${AppCSS.radiuses.small};
    background: transparent;
    cursor: pointer;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }

    &:focus-visible {
      outline: 2px solid ${AppCSS.colors.blues.primary};
      outline-offset: 2px;
    }
  `,
  ToggleIcon: styled(AngleLeftIcon)<{ $isCollapsed?: boolean }>`
    width: 24px;
    height: 24px;
    transition: transform 0.2s ease;
    transform: rotate(${(p) => (p.$isCollapsed ? 180 : 0)}deg);

    path {
      fill: ${AppCSS.colors.white};
    }
  `,
  CollapsedLogoWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    cursor: pointer;

    svg {
      width: 100%;
      height: 100%;
    }
  `,

  ImpersonateButton: styled(AppCSS.buttonStyles.SecondaryButtonStyle)<{ $isCollapsed?: boolean }>`
    width: ${(p) => (p.$isCollapsed ? '100%' : '200px')};
    min-width: 0;
    ${(p) => p.$isCollapsed && 'padding: 0 4px;'}
    ${AppCSS.radiuses.small}
    ${AppCSS.fonts.label12Bold}
    background-color: ${AppCSS.colors.gold};
    color: ${AppCSS.colors.white};
    margin-bottom: 32px;
  `,

  CollapseButtonText: styled.div`
    ${AppCSS.fonts.label14Bold};
    color: ${AppCSS.colors.white};
    cursor: pointer;
  `,

  LogoContainer: styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 40px;
    cursor: pointer;
  `,
  InnerContainer: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    overflow-y: auto;
    margin-top: 32px;
    border-top: 1px solid ${AppCSS.colors.greys.light};
    padding-top: 16px;
  `,
  VersionLabel: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.greys.light};
    margin-top: auto;
  `,
  Separator: styled.div`
    width: 100%;
    height: 1px;
    background-color: ${AppCSS.colors.greys.v2};
  `,
};
